import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useIsMobile from '../../hooks/useIsMobile';
import { FingoDialog } from './index';
import { DEFAULT_ICON_CLASS_NAME } from '../../theme/constants/icon';
import { ICON_STACK_CLASS_NAME } from '../../theme/constants/stack';
import blockDialogTitles from '../../constants/factoring/block-dialog-titles';
import { DEFAULT_UNAVAILABILITY_CODE } from '../../constants/factoring/operation-unavailability-codes';

const BlockOperationDialog = ({
  open,
  onClose,
  onConfirm,
  unavailabilityCode,
}) => {
  const theme = useTheme();
  const isMobile = useIsMobile('tablet');

  const code = unavailabilityCode ?? DEFAULT_UNAVAILABILITY_CODE;
  const blockDialogTitle = blockDialogTitles[code]
    ?? blockDialogTitles[DEFAULT_UNAVAILABILITY_CODE];
  const { title, subtitle } = blockDialogTitle;
  return (
    <FingoDialog
      titleBackgroundColor="white"
      topIcon={{
        icon: theme.branding.icons.information,
        props: {
          className: DEFAULT_ICON_CLASS_NAME,
          svgWrapperClassName: ICON_STACK_CLASS_NAME,
          sx: { width: 40, fontSize: 40 },
        },
      }}
      title={(
        <Typography
          variant="large_1"
          color="text.emphasis"
          textAlign="center"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            textAlign: 'center',
          }}
        >
          {title}
        </Typography>
      )}
      subtitle={(
        <Box
          sx={{
            mb: { xs: 1, md: 1.5 },
            px: { xs: 1, md: 1.5 },
            py: 0,
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          {subtitle}
        </Box>
            )}
      open={open}
      onClose={onClose}
      handleClose={onClose}
      maxWidth={600}
      fullWidth
      paddingContent={isMobile ? 3 : 4}
    >

      <Stack direction="row" spacing={2} justifyContent="center" width="100%" paddingTop={3}>
        <Button
          variant="secondary"
          onClick={onClose}
        >
          Volver
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            onConfirm?.();
            onClose();
          }}
        >
          Continuar y simular
        </Button>
      </Stack>
    </FingoDialog>
  );
};

BlockOperationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  unavailabilityCode: PropTypes.string,
};
BlockOperationDialog.defaultProps = {
  onConfirm: () => {},
  unavailabilityCode: DEFAULT_UNAVAILABILITY_CODE,
};
export default BlockOperationDialog;
